// @mui material components
import Card from "@mui/material/Card";


// Material Dashboard 2 React components
import MDBox from "dashboard/components/MDBox";

// Authentication layout components
import CoverLayout from "components/layouts/CoverLayout";
import NotFound from "components/Home/Pages/notFound/components/NotFound"
// Images
import bgImage from "assets/images/covers/404.webp";

function NotFoundPages() {
  return (
    <CoverLayout coverHeight="40vh" lg={12} rest  image={bgImage}>
      <Card
          sx={{
            px: { xs: 0, lg: 3 },
            mx: { xs: 0, lg: 3 },
            mt: -4,
            mb: 4,
            backgroundColor: ({ palette: { background }, functions: { rgba } }) => rgba(background.card, 0.8),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
        <MDBox pt={4} pb={3} px={{ xs: 0, lg: 3 }}>
          <NotFound/>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default NotFoundPages;